import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL + '/users';
const jsona = new Jsona();

function get(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/${params.user}/cost-of-sale?year=${params.year}`, options).then(response => {
    return {
      list: response.data,
      meta: response.data.meta
    };
  });
}

export default {
  get,
};
